import { useState, useEffect, useCallback, useRef } from "react";
import { loadToken, loadUser } from "./preferences";
import AuthState from "../../atoms/AuthState";
import { useRecoilState } from "recoil";
import { isEqual } from "lodash";

export function useTokenAndUser({ isMain = false } = {}) {
    const [authState, setAuthState] = useRecoilState(AuthState);

    const { user, token } = authState;

    const intervalRef = useRef(null);

    const [isLoading, setIsLoading] = useState(true);

    const checkTokenChange = useCallback(async () => {
        const currentToken = await loadToken();
        setAuthState((prev) => {
            if (prev?.token === currentToken) {
                return prev;
            } else {
                return { ...prev, token: currentToken };
            }
        });
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            await checkTokenChange();
            const fetchedUser = await loadUser();

            setAuthState((prev) => {
                if (isEqual(prev.user, fetchedUser)) {
                    return prev;
                } else {
                    return { ...prev, user: fetchedUser };
                }
            });
            setTimeout(() => {
                setIsLoading(false);
            }, 1000);
        };

        fetchData();
    }, [checkTokenChange]);

    useEffect(() => {
        if (!isMain) return;
        intervalRef.current = setInterval(checkTokenChange, 1000);
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [checkTokenChange, isMain]);

    return { token, user, isLoading, checkTokenChange };
}